import { gql, useQuery } from '@apollo/client';

import type {
  RemittancesUploadStatus,
  SortableField,
  SortDirection,
} from '__generated__/globalTypes';
import type {
  GetUploadRemittanceRecords,
  GetUploadRemittanceRecordsVariables,
  GetUploadRemittanceRecords_getUploadRemittanceRecords_entities,
} from './__generated__/GetUploadRemittanceRecords';

export const DEFAULT_UPLOAD_PAGE_SIZE = 100;

export const GET_UPLOAD_REMITTANCE_RECORDS = gql`
  query GetUploadRemittanceRecords($input: GetUploadRemittanceRecordsInput!) {
    getUploadRemittanceRecords(input: $input) {
      entities {
        account_id
        payment_month
        current_balance_cents
        original_balance_cents
        maturity_date
        interest_rate_basis_points
        accrued_unpaid_interest_cents
        days_past_due
        starting_balance_cents
        payment_cents
        principal_cents
        interest_cents
        charge_off
        tdr
        bankruptcy
      }
      upload_status
      summary {
        loan_count
        total_principal_cents
        total_interest_cents
      }
      total_count
    }
  }
`;

export type UploadRemittanceRecordRow =
  GetUploadRemittanceRecords_getUploadRemittanceRecords_entities;
export type { RemittancesUploadStatus };

export interface UploadRemittanceRecordsParams {
  sort?: { sort_field: SortableField; sort_direction: SortDirection };
  pagination?: { page_size: number; offset: number };
}

export function useGetUploadRemittanceRecords(
  uploadId: string | undefined,
  params?: UploadRemittanceRecordsParams,
) {
  return useQuery<GetUploadRemittanceRecords, GetUploadRemittanceRecordsVariables>(
    GET_UPLOAD_REMITTANCE_RECORDS,
    {
      variables: {
        input: {
          upload_id: uploadId ?? '',
          pagination: params?.pagination ?? { page_size: DEFAULT_UPLOAD_PAGE_SIZE, offset: 0 },
          ...(params?.sort ? { sort: params.sort } : {}),
        },
      },
      skip: !uploadId,
    },
  );
}
